import gql from 'graphql-tag';

export default gql`
    mutation EditStageSheet($input: EditStageSheetInput) {
        editStageSheet(input: $input) {
            errors
        }
    }
`;
